import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { noop } from 'rxjs';
import {
  BASE_PERMISSIONS,
  BaseCoreState,
  baseInquiryActions,
  BaseInquiryStatus,
  BaseModalService,
  BaseRolesService,
  CustomerInquiryListItemResponse,
} from 'base';
import { BaseCustomerInquiryService } from '../../../inquiry/inquiry.service';
import { BaseCustomerUnpublishedInquiryActionsEnum } from '../../_enums/base-customer-unpublished-inquiry-actions.enum';
import { BaseCustomerServiceProviderSelectService } from '../../../../shared/_services/base-customer-service-provider-select.service';
import { BaseCustomerSharedService } from '../../../../shared/_services/base-customer-shared.service';
import { BaseCustomerInquiryListItemType } from '../../../inquiry/_interfaces/base-inquiry.type';

@Component({
  selector: 'base-customer-dashboard-unpublished-inquiries',
  templateUrl: './base-customer-dashboard-unpublished-inquiries.component.html',
})
export class BaseCustomerDashboardUnpublishedInquiriesComponent implements OnChanges, OnInit {
  @ViewChild('closeInquiryModal', { static: true }) closeInquiryModal: ElementRef;
  @ViewChild('serviceProviderSelectModal', { static: true }) serviceProviderSelectModal: ElementRef;

  @Input() unpublishedInquiries: BaseCustomerInquiryListItemType[];
  states: string[] = [];
  canPublishInquiry: boolean;
  onInquiryCloseModalRef: NgbModalRef;
  serviceProviderSelectModalRef: NgbModalRef;
  inquiryActionsEnum = BaseCustomerUnpublishedInquiryActionsEnum;
  unpublishedInquiryId: number;

  constructor(
    private store: Store<BaseCoreState>,
    private modalService: BaseModalService,
    private rolesService: BaseRolesService,
    private baseCustomerInquiryService: BaseCustomerInquiryService,
    private serviceProviderService: BaseCustomerServiceProviderSelectService,
    private sharedService: BaseCustomerSharedService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['unpublishedInquiries']) {
      this.unpublishedInquiries?.forEach((inquiry) => {
        this.states.push(this.getInquiryStatus(inquiry.status as number));
      });
    }
  }

  ngOnInit(): void {
    this.canPublishInquiry = this.rolesService.hasCustomerFeaturePermission(BASE_PERMISSIONS.FEATURE_PUBLISH_INQUIRY);
  }

  getInquiryStatus(i: number) {
    return 'states.' + Object.values(BaseInquiryStatus)[i - 1];
  }

  onPublish(inquiry: CustomerInquiryListItemResponse) {
    this.unpublishedInquiryId = inquiry.id as number;

    if (!!inquiry.directlyInquired) {
      this.sharedService.publishInquiryDirectly(
        this.unpublishedInquiryId,
        inquiry.directlyInquired.profile.pspBranches,
        false,
        true
      );
    } else {
      this.serviceProviderSelectModalRef = this.serviceProviderService.openInquiryVisibilityAndNotificationsModal(
        this.serviceProviderSelectModal
      );

      this.serviceProviderSelectModalRef.result.then(() => {
        this.store.dispatch(
          baseInquiryActions.updateInquiryStatus({
            payload: {
              inquiry: this.unpublishedInquiryId,
              status: BaseInquiryStatus.published,
              loadUnpublishedInquiries: true,
            },
          })
        );
      }, noop);
    }
  }

  handleClick(actionType: BaseCustomerUnpublishedInquiryActionsEnum, inquiry: CustomerInquiryListItemResponse) {
    switch (actionType) {
      case this.inquiryActionsEnum.edit:
        this.onEdit(inquiry.id as number);
        break;
      case this.inquiryActionsEnum.release:
        this.onPublish(inquiry);
        break;
      case this.inquiryActionsEnum.close:
        this.onClose(inquiry.id as number);
        break;
    }
  }

  private onEdit(inquiryId: number) {
    this.baseCustomerInquiryService.getInquiry(inquiryId).subscribe((inquiry) => {
      this.baseCustomerInquiryService.openShiftViewPage(inquiry, inquiryId);
    });
  }

  private onClose(inquiryId: number): void {
    this.onInquiryCloseModalRef = this.modalService.open(
      {
        headText: 'inquiry.closeInquiry.headText',
        bodyTemplate: this.closeInquiryModal,
        hideFooter: true,
      },
      {
        backdrop: 'static',
        size: 'md',
      }
    );

    this.onInquiryCloseModalRef.result.then((value: string) => {
      this.updateCustomerInquiryStatus(inquiryId, BaseInquiryStatus.closed, value);
    }, noop);
  }

  private updateCustomerInquiryStatus(inquiry: number, status: 1 | 2 | 3, closedNote?: string): void {
    this.store.dispatch(
      baseInquiryActions.updateInquiryStatus({
        payload: { inquiry, status, closedNote, isDashboard: true },
      })
    );
  }

  trackByInquiry(_: number, item: CustomerInquiryListItemResponse) {
    return item.id;
  }
}
